import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import { Modal, Button } from "antd";
import { skillsdata } from "../data/skillsdata";
import Message from "../components/Message";
import Login from "../pages/Login";
import Api from "../Api";
import "../styles/requestdetails.css";
import collaboration from "../assets/collaboration.svg";
import { buildEmployer, hireEmployer } from "../actions/employerAction";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const EmployerWelcome = ({ history }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [employeesnumber, setEmployeesNumber] = useState("");
  const [skillrequest, setSkillRequest] = useState("");
  const [otherdetails, setOtherDetails] = useState("");
  const [skill, setSkill] = useState("");

  const [fileList, setFileList] = useState([]);
  const [cloudList, setCloudList] = useState([]);

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const hireEmployerState = useSelector((state) => state.employerHire);

  const { hireloading, hireerror, employerHire } = hireEmployerState;

  console.log(employerHire);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // const handleChange = (info) => {
  //   let fileList = [...info.fileList];

  //   // 1. Limit the number of uploaded files
  //   // Only to show one recent uploaded file, and old ones will be replaced by the new
  //   fileList = fileList.slice(-1);

  //   // 2. Read from response and show file link
  //   fileList = fileList.map((file) => {
  //     if (file.response) {
  //       // Component will show file.url as link
  //       file.url = file.response.url;
  //     }
  //     return file;
  //   });

  //   setFileList(fileList);
  // };

  // const dummyRequest = ({ file, onSuccess }) => {
  //   const image = new FormData();
  //   image.append("upload_preset", "fz0bvgt7");
  //   image.append("file", file);
  //   const config = {
  //     headers: { "X-Requested-With": "XMLHttpRequest" },
  //   };
  //   axios
  //     .post("https://api.cloudinary.com/v1_1/teqporte/upload", image, config)
  //     .then((res) => {
  //       const secureUrl = res.data.secure_url;
  //       const newList = [secureUrl];
  //       setCloudList(newList);
  //       setFile(newList);
  //     });
  //   setTimeout(() => {
  //     onSuccess("ok");
  //   }, 0);
  // };

  // console.log(cloudList);
  // console.log(fileList);

  const handleSelect = (newValue, actionMeta) => {
    let skillArr = newValue.map((item) => {
      return item.value;
    });
    setSkill(skillArr);
    setSkillRequest(skillArr);
  };

  const hireSubmit = (e) => {
    e.preventDefault();
    if (!skillrequest.length) {
      return message.error("Skill field is required");
    }
    dispatch(
      hireEmployer(
        company,
        country,
        employeesnumber,
        skillrequest,
        otherdetails,
        history
      )
    );
  };

  return (
    <div className="bio text-right">
      <Button className="build mr-2" onClick={showModal}>
        Hire developer for your team
      </Button>
      <Modal
        title="Hire developer"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}>
        <form onSubmit={hireSubmit}>
          {employerHire && (
            <Message variant="success">Application successful</Message>
          )}
          {hireerror && <Message variant="danger">{hireerror}</Message>}
          <p className="mb-1">
            We take great pride in matching our developers with the best
            partners. Tell us about your team below!
          </p>
          <div className="mb-1">
            <label className="mb-25 d-inline-block font-weight-bolder">
              Name of company
            </label>
            <div className="input">
              <input
                type="text"
                placeholder="Enter company name"
                onChange={(e) => setCompany(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="mb-1">
            <label className="mb-25 d-inline-block font-weight-bolder">
              Where is the Company established
            </label>
            <div className="input">
              <input
                type="text"
                name="country"
                placeholder="e.g. Germany"
                onChange={(e) => setCountry(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="mb-1">
            <label className="mb-25 d-inline-block font-weight-bolder">
              Number of employees you plan on employing
            </label>
            <div className="input">
              <input
                type="number"
                name="noe"
                placeholder="e.g. 20"
                onChange={(e) => setEmployeesNumber(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="mb-1">
            <label className="mb-25 d-inline-block font-weight-bolder">
              What skills are you looking for
            </label>
            <div className="input">
              <p className="mb-25">You can specify randomly</p>
              <CreatableSelect
                isMulti
                name="skill"
                options={skillsdata}
                onChange={handleSelect}
                className="basic-multi-select"
                classNamePrefix="select"
                required
              />
            </div>
          </div>
          <div className="">
            <label className="mb-25 d-inline-block font-weight-bolder">
              Make a request
            </label>
            <div className="input">
              <p className="mb-25">
                Might include numbers of developers needed and skills
              </p>
              <textarea
                rows="10"
                onChange={(e) => setOtherDetails(e.target.value)}
                required></textarea>
            </div>
          </div>
          <div className="my-2">
            <button
              className="d-flex justify-content-center button"
              type="submit">
              {hireloading ? <div className="spinner"></div> : "SUBMIT"}
            </button>
          </div>
        </form>
      </Modal>
      <button>
        <span>Hello {userInfo.email}, Welcome!</span>
        <span className="px-50 py-25 rounded-circle ml-25 font-weight-bold avatar font-sm">
          {userInfo.avatar}
        </span>
      </button>
    </div>
  );
};

export default EmployerWelcome;
